import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatIconModule } from '@angular/material/icon';
import { ScnackbarData, ToastService, SnackbarStyles } from '../toast.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-dlg-numero-flow',
    imports: [
        MatDialogModule, MatButtonModule,
        ClipboardModule,
        MatIconModule
    ],
    templateUrl: './dlg-numero-flow.component.html',
    styleUrl: './dlg-numero-flow.component.scss'
})
export class DlgNumeroFlowComponent {
  readonly dialogRef = inject(MatDialogRef<DlgNumeroFlowComponent>)
  readonly data = inject<{ numeroFlow: string, numeroDocumento: string }>(MAT_DIALOG_DATA);

  snackbarData: ScnackbarData = {}

  constructor(
    private toast: ToastService,
  ) { }

  onClipboardCopy() {
    this.snackbarData.message = "Copiado al portapapeles"
    this.snackbarData.style = SnackbarStyles.Success
    this.snackbarData.iconName = "check_circle"
    this.toast.show(this.snackbarData)
  }

}
